import React, { memo, useEffect, useState } from "react";
import Layout from "../components/Layout";
import AboutSection from "../components/AboutComponents/AboutSection";
import PhotoGallery from "../components/AboutComponents/PhotoGallery";

const About = () => {
  let [rooms, setRooms] = useState(19)
  const [menus, setMenus] = useState(23)
  const [staff, setStaff] = useState(190)

  return (
    <Layout>
      <div className="page-title">
        <div className="page-title-wrapper" style={{backgroundImage: "url(images/bg_2.jpg)", backgroundPosition: "center", height: "500px", backgroundSize: "cover"}}>
          <div className="content container">
            <h1 className="heading_primary">QUI SOMMES NOUS</h1>
          </div>
        </div>
      </div>

      <AboutSection />

      <div className="container">
            <div className="sc-list-info">
              <div className="row">
                <div className="col-sm-4">
                  <ul>
                    <li>
                      <i className="ion-checkmark-circled"></i>Satisfaction
                      élevée
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Service inégalé
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Wifi gratuit
                    </li>
                  </ul>
                  {/* <div className="image">
                    <img src="images/gallery/img-1.jpg" alt="" />
                  </div> */}
                </div>
                <div className="col-sm-4">
                  <ul>
                    <li>
                      <i className="ion-checkmark-circled"></i>Délicieux petit
                      déjeuner
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Service inégalé
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Catalogue des
                      produits
                    </li>
                  </ul>
                  {/* <div className="image">
                    <img src="images/gallery/img-1.jpg" alt="" />
                  </div> */}
                </div>
                <div className="col-sm-4">
                  <ul>
                    <li>
                      <i className="ion-checkmark-circled"></i>Satisfaction
                      élevée
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Bar & jardin avec
                      terrasse
                    </li>
                    <li>
                      <i className="ion-checkmark-circled"></i>Bien-être et
                      piscine
                    </li>
                  </ul>
                  {/* <div className="image">
                    <img src="images/gallery/img-1.jpg" alt="" />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
      <PhotoGallery />
    </Layout>
  );
}

export default memo(About);
